<template>
    <z-basePage :title="'充值'" :pop="true">
        <z-backForm :name="'back-budget-one'" :align="true" :btnText="'充值'" @save="saveSet" @cancel="backset">
            <!-- BU名称 -->
            <div class="back-item">
                <div class="back-title">BU名称 </div>
                <div class="back-wrap">
                    <el-select class="top-choose z-mid" rule="noVal" v-tar="buId" 
                    v-model="buId" 
                    @change="getBudgetList"
                    placeholder="请选择">
                        <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                        </z-limitOption>
                    </el-select>
                </div>
            </div>

            <!-- 操作类型 -->
            <div class="back-item">
                <div class="back-title">操作类型</div>
                <div class="back-wrap text">
                    <el-select class="top-choose z-mid" rule="noVal" v-tar="sub.type" v-model="sub.type"  @change="changeRemark" placeholder="请选择">
                        <el-option v-for="item in typeArr" :key="item.val" :value="item.val" :label="item.label">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <!-- 快币类型 -->
            <!-- <div class="back-item">
                <div class="back-title">快币类型</div>
                <div class="back-wrap">
                    <el-select class="top-choose z-mid" rule="noVal" v-tar="sub.id" v-model="sub.id" placeholder="请选择" >
                        <el-option v-for="item in currency_list" :key="item.id" :value="item.id" :label="item.currencyName">
                        </el-option>
                    </el-select>
                </div>
            </div> -->

            <!-- 充值金额 -->
            <div class="back-item">
                <div class="back-title">充值金额</div>
                <div class="back-wrap">
                    <el-input class="top-choose z-mid" rule="noVal integer" v-tar="sub.amount" v-model="sub.amount" placeholder="请输入充值金额">
                        <template slot="append">{{ task_curr.currency_name }}</template>
                    </el-input>
                </div>
            </div>

            <!-- 备注 -->
            <div class="back-item area">
                <div class="back-title">备注</div>
                <div class="back-wrap">
                    <textarea rule="reason describe_limit" v-arg="'备注'" v-tar="sub.remark" v-model="sub.remark" placeholder="请输入备注"></textarea>
                </div>
            </div>

        </z-backForm>
    </z-basePage>
</template>

<script>
    import { mapGetters } from "vuex"

    export default {
        data(){
            return {
                sub:{
                    bu_id:"",
                    type:"",   //操作类型
                    // id:"",     //快币id
                    amount:"", //充值金额
                    remark:"", //备注
                },
                typeArr:[
                    {
                        val:1,
                        label:"预算充值",
                    },
                    {
                        val:2,
                        label:"预算扣除",
                    },
                ],
                // sub:[
                //     "",  //Bu id 
                //     "",  //操作类型
                //     "",  //快币id
                //     "",  //充值金额
                //     "",  //备注
                // ],
                bu_list:[],
                currency_list:[],
            }
        },

        computed:{
            // ...mapState(['currencyList']),
            ...mapGetters(['task_curr']),
            buId:{
                get(){
                    return this.sub.bu_id || this.$crypto.decrypt(this.$route.params.id);
                },
                set(id){
                    this.sub.bu_id = id;
                },
            },
        },

        
        created(){
            this.$func.getBuList(true,list=>{
                this.bu_list = list;
            })
        },    
        beforeRouteLeave(to,from,next){  //离开页面之前
            let res = this.$form.leave({name:'back-budget-one',path:to.path});
                // res = this.$form.leave({name:'back-budget-auto',path:to.path});
			next(res);
        },    

        methods:{
            getBudgetList(id){
                if(id){
                    let url = `api/bu/bugdet_currency/${id}`;
                    this.$http.get(url).then(res=>{
                        if(res.status == 200){
                            this.currency_list = res.res_data;
                        }
                    })
                }
            },
            changeRemark(type){
                if(type == 1){
                    this.sub.remark = '管理员人工充值预算';
                }else if(type == 2){
                    this.sub.remark = '管理员人工扣除预算';
                }
            },

            saveSet(){  //保存
                let url =`api/admin/budget/recharge`;
                // let url = `api/admin/currency_budget/${this.sub.bu_id}`;
                let obj = {
                    bu_id:this.buId,
                    bill_type:this.sub.type,
                    // currency_id:this.sub.id,
                    trans_amount:parseInt(this.sub.amount),
                    remark:this.sub.remark,
                }

                this.$func.loading(true);
                this.$http.put(url,obj).then(res=>{
                    if(res.status == 200){
                        this.successTip("充值成功");
                        this.$router.push({
                            name:'back-finance-budget',
                        });
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("充值失败");
                    this.$func.loading(false);
                });

            },
            backset(dataArr){
                [
                    this.sub.bu_id,
                    this.sub.type,   
                    // this.sub.id,     
                    this.sub.amount,
                    this.sub.remark, 
                ] = dataArr;
            }

        },

    }
</script>

<style lang="less" scoped>
    .tab-title{
        margin-top: 15px;
    }
</style>





// WEBPACK FOOTER //
// page-budget-recharge-add.vue?5d477595